import { useEffect, useState } from 'react';

import useColor from '@/hooks/domain/useColor';
import useExportStore from '@/stores/ExportStore';

import { CenterFlex } from '../base';
import Spinner from '../Common/Spinner';
import TransitionPortal from '../Common/TransitionPortal';
import Typo from '../Typography/Typo';

export const ExportLoader = () => {
  const color = useColor();
  const exporting = useExportStore((state) => state.exporting);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (exporting) {
      setShow(exporting);
    } else {
      setShow(exporting);
    }
  }, [exporting]);

  return (
    <TransitionPortal
      layerId="page-loading-layer"
      status={show}
      background={{ enable: false }}
      style={{
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        padding: 16,
        borderRadius: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: color.gray900,
        color: color.gray100,
      }}
    >
      <CenterFlex g={16}>
        <Spinner color={color.gray100} />
        <Typo type="label2">Exporting feedback</Typo>
        <Typo
          type="label3"
          weight="sb"
          className="underline cursor-pointer"
          onClick={() => setShow(false)}
        >
          Hide
        </Typo>
      </CenterFlex>
    </TransitionPortal>
  );
};
